var _a;
import { EPaymentDisputeReasonType } from "../types/paymentDispute.types";
import { getLocalizedText } from "./i18n/i18n.utils";
// Single source of truth for the reason type -> friendly label mapping. Typed as
// a full Record so adding a value to EPaymentDisputeReasonType fails to compile
// until its label is added here too.
var DISPUTE_REASON_TYPE_I18N_KEYS = (_a = {},
    _a[EPaymentDisputeReasonType.AuthorizationDisputed] = "payment_dispute.reason_type.authorization_disputed",
    _a[EPaymentDisputeReasonType.CanceledRecurringTransaction] = "payment_dispute.reason_type.canceled_recurring_transaction",
    _a[EPaymentDisputeReasonType.Duplicate] = "payment_dispute.reason_type.duplicate",
    _a[EPaymentDisputeReasonType.Fraud] = "payment_dispute.reason_type.fraud",
    _a[EPaymentDisputeReasonType.LateFailureBankAccountClosed] = "payment_dispute.reason_type.late_failure_bankaccount_closed",
    _a[EPaymentDisputeReasonType.LateFailureBankAccountIncompatible] = "payment_dispute.reason_type.late_failure_bankaccount_incompatible",
    _a[EPaymentDisputeReasonType.LateFailureBankAccountIncorrect] = "payment_dispute.reason_type.late_failure_bankaccount_incorrect",
    _a[EPaymentDisputeReasonType.LateFailureContactUser] = "payment_dispute.reason_type.late_failure_contact_user",
    _a[EPaymentDisputeReasonType.LateFailureInsufficientFunds] = "payment_dispute.reason_type.late_failure_insufficient_funds",
    _a[EPaymentDisputeReasonType.Other] = "payment_dispute.reason_type.other",
    _a[EPaymentDisputeReasonType.ProductNotProvided] = "payment_dispute.reason_type.product_not_provided",
    _a[EPaymentDisputeReasonType.ProductUnacceptable] = "payment_dispute.reason_type.product_unacceptable",
    _a[EPaymentDisputeReasonType.RefundConversionRate] = "payment_dispute.reason_type.refund_conversion_rate",
    _a[EPaymentDisputeReasonType.RefundNotProcessed] = "payment_dispute.reason_type.refund_not_processed",
    _a[EPaymentDisputeReasonType.TransactionNotRecognized] = "payment_dispute.reason_type.transaction_not_recognized",
    _a[EPaymentDisputeReasonType.Unknown] = "payment_dispute.reason_type.unknown",
    _a);
// Readable fallback for reason types MangoPay introduces after this mapping was
// written: "SOME_NEW_REASON" -> "Some new reason". getLocalizedText cannot be
// used for these, as it returns the key itself when no translation exists.
var getFallbackLabel = function (reasonType) {
    var readable = reasonType.replace(/_/g, " ").toLowerCase().trim();
    return "".concat(readable.charAt(0).toUpperCase()).concat(readable.slice(1));
};
export var getDisputeReasonTypeLabel = function (reasonType) {
    if (!reasonType) {
        return undefined;
    }
    var i18nKey = DISPUTE_REASON_TYPE_I18N_KEYS[reasonType];
    if (i18nKey) {
        return getLocalizedText(i18nKey);
    }
    return getFallbackLabel(reasonType);
};
